/**
 * The marketing site and the app share one GA4 property, G-B48N4YEGNE.
 * linker.domains plus cookie_domain auto keep the original session when a
 * creator moves between withme.so, the app, and fitwith.io. Campaign params
 * are not sent on the event: the session source is the one GA already has.
 *
 * Consent matches index.html consentOK. Advertising consent is a different
 * check and is not used here. When CookieYes is absent (local, or a property
 * that does not load it) analytics is treated as allowed, same as the tag
 * that already ships.
 */

export const GA_MEASUREMENT_ID = 'G-B48N4YEGNE';

export const GA_LINKER_DOMAINS = ['withme.so', 'fitwith.io', 'fitwithofficial.com'];

export const GA_INSTALL_CONFIG = {
   linker: {
      domains: GA_LINKER_DOMAINS,
      accept_incoming: true,
   },
   cookie_domain: 'auto',
};

export const CREATOR_TRIAL_SIGNUP_FLAG = 'wm_creator_trial_signup';

export function analyticsConsentGranted() {
   try {
      return !window.cookieyes
         || (window.cookieyes.consent
            && (window.cookieyes.consent.analytics || window.cookieyes.consent.performance));
   } catch (e) {
      return true;
   }
}

function ensureGtag() {
   if (typeof window.gtag === 'function') return;
   window.dataLayer = window.dataLayer || [];
   window.gtag = function gtag() { window.dataLayer.push(arguments); };
   window.gtag('js', new Date());
   window.gtag('config', GA_MEASUREMENT_ID, {
      ...GA_INSTALL_CONFIG,
      send_page_view: false,
   });
   try {
      const already = document.querySelector('script[src*="gtag/js?id=' + GA_MEASUREMENT_ID + '"]');
      if (!already) {
         const script = document.createElement('script');
         script.async = true;
         script.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_MEASUREMENT_ID;
         (document.head || document.documentElement).appendChild(script);
      }
   } catch (e) {
      // the event is still queued on dataLayer
   }
}

/**
 * sign_up for a creator trial that has actually started. No-op without
 * analytics consent. Never throws: a blocked tag must not affect checkout.
 */
export function trackCreatorTrialSignUp() {
   try {
      if (!analyticsConsentGranted()) return;
      ensureGtag();
      window.gtag('event', 'sign_up', {
         send_to: GA_MEASUREMENT_ID,
         method: 'creator_trial',
         transport_type: 'beacon',
      });
   } catch (e) {
      // reporting only
   }
}

export function markCreatorTrialSignUp() {
   try {
      window.sessionStorage.setItem(CREATOR_TRIAL_SIGNUP_FLAG, '1');
   } catch (e) {
      // the redirect still happens; the event is skipped
   }
}

/** Fires sign_up once when the trial success page sees the flag, then clears it. */
export function consumeCreatorTrialSignUp() {
   try {
      if (window.sessionStorage.getItem(CREATOR_TRIAL_SIGNUP_FLAG) !== '1') return false;
      window.sessionStorage.removeItem(CREATOR_TRIAL_SIGNUP_FLAG);
      trackCreatorTrialSignUp();
      return true;
   } catch (e) {
      return false;
   }
}
